import { useCallback } from 'react';
import { isVideoCampaign } from '../../../services/campaignDimension';
import { ENTITY } from '../config';
import { AllEntityId } from '../config/allEntityId';
import { useReportEntityType } from './useReportEntityType';
import { useSelectedCampaign } from './useSelectedCampaign';
import { useSelectedCampaignGroup } from './useSelectedCampaignGroup';

const useCampaignHeader = ({ onEditEntity }) => {
    const { campaign: selectedCampaign } = useSelectedCampaign();
    const { campaignGroup: selectedCampaignGroup } = useSelectedCampaignGroup();
    const [entityType] = useReportEntityType();
    const { onEditCampaign, onEditCampaignGroup } = onEditEntity || {};

    const handleEdit = useCallback(() => {
        if (entityType === ENTITY.CAMPAIGN) {
            onEditCampaign(selectedCampaign);
        }
        if (entityType === ENTITY.CAMPAIGNS_GROUP) {
            onEditCampaignGroup(selectedCampaignGroup);
        }
    }, [entityType, onEditCampaign, onEditCampaignGroup, selectedCampaign, selectedCampaignGroup]);

    const shouldRenderEdit =
        (!!onEditCampaign || !!onEditCampaignGroup) &&
        entityType !== AllEntityId &&
        !isVideoCampaign(selectedCampaign.dimension);

    return {
        shouldRenderEdit,
        handleEdit,
    };
};

export default useCampaignHeader;
